// extracted by mini-css-extract-plugin
module.exports = {"icon":"modal_icon__YwW7J","iconLight":"modal_iconLight__1kyU2","circle":"modal_circle__2P7tM"};